<article class="block-intro section-inset-y container">
  <h2 class="h6 block-intro__subtitle" *ngIf="block.title" [innerHTML]="block.title"></h2>
</article>
